var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.538 17.9273V26.6769L27.5379 26.6769L27.538 44.176H18.754L18.7539 26.6769L9.96997 26.6769V17.9273H27.538Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0853 44.176V35.4265L32.0854 35.4265L32.0853 17.9273L40.8693 17.9273L40.8694 35.4265L49.6533 35.4265V44.176H32.0853Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5198 1H1V61H58.5198V1Z",
    stroke: "black",
    strokeWidth: 1.48812
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterlogo);
export default __webpack_public_path__ + "static/media/footerlogo.78cb871ef1c3d38332f4064c528bdc93.svg";
export { ForwardRef as ReactComponent };